// Modules
import { useSelector, useDispatch } from "react-redux";
// Actions
import { RootState } from "@/config/store";
import { hideModal } from "@/config/store/modalReducer";
// Components
import SubstitutesDialog from "../Dashboard/components/SubstitutesDialog";
import FeedbackDialog from "../Dashboard/components/FeedbackDialog";

const modalComponents = {
    substitute: SubstitutesDialog,
    feedback: FeedbackDialog
};

export const GlobalModalHost = () => {
    const dispatch = useDispatch();
    const modalType = useSelector((state: RootState) => state.modal.modalType);
    if (!modalType) return null;

    const ModalComponent = modalComponents[modalType];
    if (!ModalComponent) return null;

    return <ModalComponent isOpen={true} closeModal={(modalName: string) => dispatch(hideModal(modalName))} />;
};
